<template>
  <div class="root">
    <FormulateInput
      v-bind="{ ...$props, ...$attrs }"
      type="checkbox"
      validation="required"
      :options="options"
      data-no-card
      @input="handleChange"
    />
  </div>
</template>

<script>
export default {
  name: 'AllToggleCheckboxes',
  props: {
    name: {
      type: String,
      required: true,
    },
    options: {
      type: Object,
      required: true,
    },
    toggleKey: {
      type: String,
      required: true,
    },
  },
  methods: {
    handleChange(model) {
      if (model.indexOf(this.toggleKey) > 0) {
        model.splice(0, model.length, this.toggleKey);
      }

      if (model.indexOf(this.toggleKey) === 0 && model.length > 1) {
        model.splice(0, 1);
      }

      if (model.length === 0) {
        model.push(this.toggleKey);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.root {
  >>> .formulate-input-group {
    columns: 2;
  }
}
</style>
